// Mock Services Layer - Prepared for Odoo Integration
// Este archivo contiene datos demo de Manklar que serán reemplazados con llamadas API de Odoo

// Catálogo de Equipos Manklar Oficiales
export const MANKLAR_EQUIPMENT_CATALOG = {
  KAJAAL: {
    id: 'KAJAAL',
    name: 'MANKLAR KAJAAL',
    features: ['Agua del tiempo'],
    coldWater: false,
    hotWater: false,
    coldTankCapacity: null,
    description: 'Dispensador básico con agua del tiempo',
    priceHome: 29.90,
    priceBusiness: 29.90,
    priceBusinessVAT: true, // +IVA para empresa
    deposit: 69.00,
    currency: 'EUR'
  },
  TIKAL: {
    id: 'TIKAL',
    name: 'MANKLAR TIKAL',
    features: ['Agua fría', 'Agua caliente', 'Agua del tiempo'],
    coldWater: true,
    hotWater: true,
    coldTankCapacity: '3,5 litros',
    description: 'Dispensador completo con agua fría, caliente y del tiempo',
    priceHome: 34.90,
    priceBusiness: 34.90,
    priceBusinessVAT: true,
    deposit: 69.00,
    currency: 'EUR'
  },
  TIKAL_S: {
    id: 'TIKAL_S',
    name: 'MANKLAR TIKAL S',
    features: ['Agua fría', 'Agua caliente', 'Agua del tiempo', 'Formato compacto'],
    coldWater: true,
    hotWater: true,
    coldTankCapacity: '1,7 litros',
    description: 'Versión compacta del TIKAL, ideal para espacios reducidos',
    priceHome: 34.90,
    priceBusiness: 34.90,
    priceBusinessVAT: true,
    deposit: 69.00,
    currency: 'EUR'
  },
  CHAAK: {
    id: 'CHAAK',
    name: 'MANKLAR CHAAK',
    features: ['Agua fría', 'Agua caliente', 'Agua del tiempo', '8 litros de capacidad de agua fría'],
    coldWater: true,
    hotWater: true,
    coldTankCapacity: '8 litros',
    description: 'Dispensador premium con la mayor capacidad de agua fría',
    priceHome: 44.90,
    priceBusiness: 44.90,
    priceBusinessVAT: true,
    deposit: 69.00,
    currency: 'EUR'
  }
};

// Información del servicio Manklar
export const MANKLAR_SERVICE_INFO = {
  included: [
    'Instalación incluida',
    'Cambio anual de filtros incluido',
    'Mantenimiento preventivo anual incluido',
    'Servicio técnico incluido',
    'Garantía Manklar ilimitada mientras mantengas activo el servicio'
  ],
  maintenanceFrequency: 'anual',
  extraMaintenanceCost: 59.00,
  warranty: {
    description: 'La Garantía Manklar cubre averías mientras el cliente mantenga activo el servicio y cumpla las condiciones establecidas.',
    incidentResolutionTime: '48 horas laborables',
    compensationIfNotResolved: 'Si una avería comunicada no queda resuelta en un plazo máximo de 48 horas laborables, Manklar abonará la siguiente mensualidad correspondiente al equipo afectado.'
  }
};

// Customer Service
export const CustomerService = {
  async getProfile(userId) {
    // TODO: Replace with Odoo API call - res.partner
    return {
      id: userId || 'CUST-001',
      customerNumber: 'MNK-2024-0001',
      name: 'Cliente Demo',
      email: 'cliente@manklar.com',
      phone: '+34 612 345 678',
      address: {
        street: 'Calle Gran Vía 28',
        colony: 'Centro',
        city: 'Madrid',
        state: 'Madrid',
        zipCode: '28013',
        country: 'España'
      },
      customerSince: '2024-01-15',
      status: 'active',
      clientType: 'hogar',
      avatar: null
    };
  },

  async updateProfile(userId, data) {
    console.log('Profile update:', data);
    return { success: true };
  }
};

// Equipment Service
export const EquipmentService = {
  async getEquipments(customerId) {
    const equipment = MANKLAR_EQUIPMENT_CATALOG.CHAAK;
    return [
      {
        id: 'EQ-001',
        name: equipment.name,
        model: equipment.id,
        serialNumber: 'MNK24-001234',
        status: 'active',
        installationDate: '2024-01-20',
        nextMaintenance: '2025-01-20',
        location: 'Cocina',
        features: equipment.features,
        coldTankCapacity: equipment.coldTankCapacity,
        monthlyPrice: equipment.priceHome,
        deposit: equipment.deposit,
        currency: equipment.currency,
        image: null,
        warranty: MANKLAR_SERVICE_INFO.warranty.description
      }
    ];
  },

  async getEquipmentDetails(equipmentId) {
    const equipment = MANKLAR_EQUIPMENT_CATALOG.CHAAK;
    return {
      id: equipmentId,
      name: equipment.name,
      model: equipment.id,
      serialNumber: 'MNK24-001234',
      status: 'active',
      installationDate: '2024-01-20',
      nextMaintenance: '2025-01-20',
      location: 'Cocina',
      features: equipment.features,
      coldTankCapacity: equipment.coldTankCapacity,
      monthlyPrice: equipment.priceHome,
      deposit: equipment.deposit,
      currency: equipment.currency,
      warranty: MANKLAR_SERVICE_INFO.warranty.description,
      maintenanceHistory: [
        {
          date: '2024-01-20',
          type: 'Instalación',
          technician: 'Técnico Manklar',
          notes: 'Instalación inicial del equipo con filtros nuevos'
        }
      ],
      serviceInfo: MANKLAR_SERVICE_INFO.included
    };
  },

  getCatalog() {
    return MANKLAR_EQUIPMENT_CATALOG;
  }
};

// Subscription Service
export const SubscriptionService = {
  async getSubscription(customerId) {
    const equipment = MANKLAR_EQUIPMENT_CATALOG.CHAAK;
    return {
      id: 'SUB-001',
      planName: equipment.name,
      planDescription: 'Servicio completo de agua purificada Manklar',
      monthlyPrice: equipment.priceHome,
      currency: 'EUR',
      status: 'active',
      startDate: '2024-01-15',
      nextBillingDate: '2025-02-15',
      paymentMethod: 'Tarjeta terminación 4532',
      clientType: 'hogar',
      deposit: equipment.deposit,
      depositPaid: true,
      features: MANKLAR_SERVICE_INFO.included,
      equipmentFeatures: equipment.features,
      coldTankCapacity: equipment.coldTankCapacity,
      discount: {
        type: 'referral',
        amount: 0,
        description: null
      },
      warranty: MANKLAR_SERVICE_INFO.warranty
    };
  },

  async getPlans() {
    return Object.values(MANKLAR_EQUIPMENT_CATALOG).map(eq => ({
      id: eq.id,
      name: eq.name,
      priceHome: eq.priceHome,
      priceBusiness: eq.priceBusiness,
      priceBusinessVAT: eq.priceBusinessVAT,
      deposit: eq.deposit,
      features: eq.features,
      coldTankCapacity: eq.coldTankCapacity,
      description: eq.description,
      serviceIncluded: MANKLAR_SERVICE_INFO.included
    }));
  }
};

// Billing Service
export const BillingService = {
  async getInvoices(customerId) {
    const equipment = MANKLAR_EQUIPMENT_CATALOG.CHAAK;
    return [
      {
        id: 'INV-2025-001',
        number: 'MNK-2025-000012',
        date: '2025-01-01',
        dueDate: '2025-01-15',
        amount: equipment.priceHome,
        currency: 'EUR',
        status: 'pending',
        concept: `Cuota mensual ${equipment.name} - Enero 2025`,
        pdfUrl: null
      },
      {
        id: 'INV-2024-012',
        number: 'MNK-2024-000198',
        date: '2024-12-01',
        dueDate: '2024-12-15',
        amount: equipment.priceHome,
        currency: 'EUR',
        status: 'paid',
        concept: `Cuota mensual ${equipment.name} - Diciembre 2024`,
        pdfUrl: null,
        paidDate: '2024-12-10'
      },
      {
        id: 'INV-2024-011',
        number: 'MNK-2024-000156',
        date: '2024-11-01',
        dueDate: '2024-11-15',
        amount: equipment.priceHome,
        currency: 'EUR',
        status: 'paid',
        concept: `Cuota mensual ${equipment.name} - Noviembre 2024`,
        pdfUrl: null,
        paidDate: '2024-11-08'
      },
      {
        id: 'INV-2024-010',
        number: 'MNK-2024-000112',
        date: '2024-10-01',
        dueDate: '2024-10-15',
        amount: equipment.priceHome,
        currency: 'EUR',
        status: 'paid',
        concept: `Cuota mensual ${equipment.name} - Octubre 2024`,
        pdfUrl: null,
        paidDate: '2024-10-12'
      }
    ];
  },

  async downloadInvoice(invoiceId) {
    console.log('Downloading invoice:', invoiceId);
    return { success: true, message: 'PDF descargado' };
  },

  async getNextBill(customerId) {
    const equipment = MANKLAR_EQUIPMENT_CATALOG.CHAAK;
    return {
      amount: equipment.priceHome,
      currency: 'EUR',
      dueDate: '2025-02-15',
      concept: `Cuota mensual ${equipment.name} - Febrero 2025`
    };
  }
};

// Maintenance Service
export const MaintenanceService = {
  async getMaintenanceRequests(customerId) {
    return [
      {
        id: 'MNT-001',
        type: 'preventive',
        status: 'scheduled',
        scheduledDate: '2025-01-20',
        description: 'Mantenimiento preventivo anual programado',
        technician: 'Por asignar',
        createdAt: '2025-01-01'
      }
    ];
  },

  async createRequest(customerId, data) {
    console.log('Creating maintenance request:', data);
    return {
      success: true,
      ticketId: 'MNT-' + Date.now(),
      message: 'Solicitud creada correctamente. Nos pondremos en contacto contigo en breve.'
    };
  },

  async getRequestTypes() {
    return [
      { id: 'maintenance', label: 'Mantenimiento preventivo', icon: 'wrench', description: 'Mantenimiento anual incluido. Si solicitas antes del año: 59€' },
      { id: 'revision', label: 'Revisión técnica', icon: 'search', description: 'Diagnóstico del equipo por técnico Manklar' },
      { id: 'incident', label: 'Reportar incidencia', icon: 'alert', description: 'Comunica cualquier problema con tu equipo' },
      { id: 'removal', label: 'Solicitar retirada', icon: 'truck', description: 'Cancelar servicio y recoger equipo' }
    ];
  },

  getServiceInfo() {
    return MANKLAR_SERVICE_INFO;
  }
};

// Referral Service
export const ReferralService = {
  async getReferrals(userId) {
    return null;
  },

  async getStats(userId) {
    return null;
  },

  getProgramInfo() {
    return {
      steps: [
        'Comparte tu código o enlace personal con amigos y familia',
        'Tu referido se convierte en cliente de Manklar',
        'Cuando complete 3 meses de servicio activo, pasa a estado VALIDADO',
        'Recibes 1 mes gratis por cada referido validado',
        'Al alcanzar 10 referidos validados: +6 meses gratis adicionales'
      ],
      rewardPerReferral: 1,
      bonusAt: 10,
      bonusReward: 6
    };
  }
};

// ============================================================
// ODOO INTEGRATION STUBS - Ready for future implementation
// These services will connect to Odoo API when integrated
// ============================================================

// Commercial Agents Service (Comerciales)
// Will connect to: res.users with sales team
export const CommercialService = {
  async getAll() {
    // TODO: Connect to Odoo res.users filtered by sales team
    return [
      { id: 'COM-001', name: 'Carlos García', email: 'carlos@manklar.com', phone: '+34 600 111 222', active: true, assigned_clients: 15 },
      { id: 'COM-002', name: 'María López', email: 'maria@manklar.com', phone: '+34 600 333 444', active: true, assigned_clients: 12 }
    ];
  },

  async getById(id) {
    // TODO: Connect to Odoo res.users
    return null;
  },

  async assignToClient(commercialId, clientId) {
    // TODO: Connect to Odoo to update res.partner
    console.log('AssignToClient - Odoo integration pending:', { commercialId, clientId });
    return { success: true };
  }
};

// Technicians Service (Técnicos)
// Will connect to: res.users with technician role
export const TechnicianService = {
  async getAll() {
    // TODO: Connect to Odoo res.users filtered by technician role
    return [
      { id: 'TECH-001', name: 'Pedro Martínez', email: 'pedro@manklar.com', phone: '+34 600 555 666', active: true, zone: 'Madrid Centro' },
      { id: 'TECH-002', name: 'Ana Ruiz', email: 'ana@manklar.com', phone: '+34 600 777 888', active: true, zone: 'Madrid Norte' }
    ];
  },

  async getById(id) {
    // TODO: Connect to Odoo res.users
    return null;
  },

  async assignToClient(technicianId, clientId) {
    // TODO: Connect to Odoo to update res.partner
    console.log('AssignTechnician - Odoo integration pending:', { technicianId, clientId });
    return { success: true };
  },

  async getAvailability(technicianId, date) {
    // TODO: Connect to Odoo calendar
    return { available: true, slots: ['09:00', '11:00', '14:00', '16:00'] };
  }
};

// Installations Service (Instalaciones)
// Will connect to: project.task or custom module
export const InstallationService = {
  async getAll(filters = {}) {
    // TODO: Connect to Odoo project.task or custom installation module
    return [];
  },

  async getById(id) {
    // TODO: Connect to Odoo
    return null;
  },

  async schedule(clientId, data) {
    // TODO: Connect to Odoo to create installation task
    console.log('ScheduleInstallation - Odoo integration pending:', { clientId, data });
    return { 
      success: true, 
      installation_id: 'INS-' + Date.now(),
      scheduled_date: data.date 
    };
  },

  async complete(installationId, data) {
    // TODO: Connect to Odoo to mark installation complete
    console.log('CompleteInstallation - Odoo integration pending:', { installationId, data });
    return { success: true };
  },

  async cancel(installationId, reason) {
    // TODO: Connect to Odoo
    console.log('CancelInstallation - Odoo integration pending:', { installationId, reason });
    return { success: true };
  },

  getStatuses() {
    return [
      { id: 'pending', label: 'Pendiente', color: 'yellow' },
      { id: 'scheduled', label: 'Programada', color: 'blue' },
      { id: 'in_progress', label: 'En curso', color: 'purple' },
      { id: 'completed', label: 'Completada', color: 'green' },
      { id: 'cancelled', label: 'Cancelada', color: 'red' }
    ];
  }
};

// Maintenance Service Extended for Admin (Mantenimientos)
// Will connect to: helpdesk.ticket or custom module
export const MaintenanceAdminService = {
  async getAll(filters = {}) {
    // TODO: Connect to Odoo helpdesk.ticket or maintenance module
    return [];
  },

  async getById(id) {
    // TODO: Connect to Odoo
    return null;
  },

  async schedule(clientId, data) {
    // TODO: Connect to Odoo
    console.log('ScheduleMaintenance - Odoo integration pending:', { clientId, data });
    return { 
      success: true, 
      maintenance_id: 'MNT-' + Date.now(),
      scheduled_date: data.date 
    };
  },

  async complete(maintenanceId, data) {
    // TODO: Connect to Odoo
    console.log('CompleteMaintenance - Odoo integration pending:', { maintenanceId, data });
    return { success: true };
  },

  async assignTechnician(maintenanceId, technicianId) {
    // TODO: Connect to Odoo
    console.log('AssignMaintenanceTechnician - Odoo integration pending:', { maintenanceId, technicianId });
    return { success: true };
  },

  getTypes() {
    return [
      { id: 'preventive', label: 'Mantenimiento preventivo', frequency: 'anual', included: true },
      { id: 'corrective', label: 'Mantenimiento correctivo', frequency: 'on_demand', included: false },
      { id: 'filter_change', label: 'Cambio de filtros', frequency: 'anual', included: true },
      { id: 'emergency', label: 'Emergencia', frequency: 'on_demand', included: false }
    ];
  }
};

// Leads Service (Leads/Oportunidades)
// Will connect to: crm.lead
export const LeadService = {
  async getAll(filters = {}) {
    // TODO: Connect to Odoo crm.lead
    return [];
  },

  async getById(id) {
    // TODO: Connect to Odoo
    return null;
  },

  async create(data) {
    // TODO: Connect to Odoo crm.lead
    console.log('CreateLead - Odoo integration pending:', data);
    return { 
      success: true, 
      lead_id: 'LEAD-' + Date.now() 
    };
  },

  async updateStage(leadId, stageId) {
    // TODO: Connect to Odoo
    console.log('UpdateLeadStage - Odoo integration pending:', { leadId, stageId });
    return { success: true };
  },

  async convertToClient(leadId) {
    // TODO: Connect to Odoo to convert lead to customer
    console.log('ConvertLeadToClient - Odoo integration pending:', { leadId });
    return { success: true, client_id: 'CLIENT-' + Date.now() };
  },

  getStages() {
    return [
      { id: 'new', label: 'Nuevo', probability: 10 },
      { id: 'contacted', label: 'Contactado', probability: 30 },
      { id: 'qualified', label: 'Cualificado', probability: 50 },
      { id: 'trial_scheduled', label: 'Prueba agendada', probability: 70 },
      { id: 'won', label: 'Ganado', probability: 100 },
      { id: 'lost', label: 'Perdido', probability: 0 }
    ];
  }
};

// Billing Admin Service (Facturación Admin)
// Will connect to: account.move
export const BillingAdminService = {
  async getAll(filters = {}) {
    // TODO: Connect to Odoo account.move
    return [];
  },

  async getById(id) {
    // TODO: Connect to Odoo
    return null;
  },

  async createInvoice(clientId, data) {
    // TODO: Connect to Odoo account.move
    console.log('CreateInvoice - Odoo integration pending:', { clientId, data });
    return { 
      success: true, 
      invoice_id: 'INV-' + Date.now() 
    };
  },

  async applyCredit(clientId, data) {
    // TODO: Connect to Odoo to apply credit note
    console.log('ApplyCredit - Odoo integration pending:', { clientId, data });
    return { success: true };
  },

  async markPaid(invoiceId, paymentData) {
    // TODO: Connect to Odoo
    console.log('MarkInvoicePaid - Odoo integration pending:', { invoiceId, paymentData });
    return { success: true };
  },

  async applyBonification(clientId, month, referralId) {
    // TODO: Connect to Odoo to apply free month
    console.log('ApplyBonification - Odoo integration pending:', { clientId, month, referralId });
    return { success: true };
  },

  getPaymentMethods() {
    return [
      { id: 'card', label: 'Tarjeta de crédito/débito' },
      { id: 'transfer', label: 'Transferencia bancaria' },
      { id: 'direct_debit', label: 'Domiciliación bancaria' }
    ];
  }
};

// Contracts Service (Contratos)
// Will connect to: subscription or custom module
export const ContractService = {
  async getAll(filters = {}) {
    // TODO: Connect to Odoo subscription module
    return [];
  },

  async getById(id) {
    // TODO: Connect to Odoo
    return null;
  },

  async create(clientId, data) {
    // TODO: Connect to Odoo
    console.log('CreateContract - Odoo integration pending:', { clientId, data });
    return { 
      success: true, 
      contract_id: 'CONT-' + Date.now() 
    };
  },

  async terminate(contractId, reason) {
    // TODO: Connect to Odoo
    console.log('TerminateContract - Odoo integration pending:', { contractId, reason });
    return { success: true };
  },

  async generatePDF(contractId) {
    // TODO: Connect to Odoo report
    console.log('GenerateContractPDF - Odoo integration pending:', { contractId });
    return { success: true, pdf_url: null };
  }
};

// Odoo Sync Service - Master sync controller
export const OdooSyncService = {
  isConnected: false,
  lastSync: null,

  async testConnection() {
    // TODO: Test Odoo API connection
    console.log('TestOdooConnection - Integration pending');
    return { connected: false, message: 'Odoo integration not configured' };
  },

  async syncClients() {
    // TODO: Sync clients from Odoo res.partner
    console.log('SyncClients - Odoo integration pending');
    return { success: false, synced: 0 };
  },

  async syncReferrals() {
    // TODO: Sync referral data
    console.log('SyncReferrals - Odoo integration pending');
    return { success: false, synced: 0 };
  },

  async syncAll() {
    // TODO: Full sync with Odoo
    console.log('FullSync - Odoo integration pending');
    return { 
      success: false, 
      message: 'Odoo integration not configured',
      details: {
        clients: 0,
        referrals: 0,
        invoices: 0,
        maintenances: 0
      }
    };
  }
};

export default {
  CustomerService,
  EquipmentService,
  SubscriptionService,
  BillingService,
  MaintenanceService,
  ReferralService,
  // Odoo Admin Services
  CommercialService,
  TechnicianService,
  InstallationService,
  MaintenanceAdminService,
  LeadService,
  BillingAdminService,
  ContractService,
  OdooSyncService,
  // Catalogs
  MANKLAR_EQUIPMENT_CATALOG,
  MANKLAR_SERVICE_INFO
};
